import React, { useMemo, useState } from 'react';
import { Box, Paper, Typography, Tabs, Tab } from '@mui/material';
import FeasibilityQuestionnaire from './feasibility/FeasibilityQuestionnaire';
import CountryFeasibility from './feasibility/CountryFeasibility';
import SiteFeasibility from './feasibility/SiteFeasibility';

const tabConfig = [
  { id: 'feasibility-questionnaire', label: 'Feasibility Questionnaire' },
  { id: 'country-feasibility', label: 'Country Feasibility' },
  { id: 'site-feasibility', label: 'Site Feasibility' },
];

const Feasibility = () => {
  const [activeTab, setActiveTab] = useState(tabConfig[0].id);

  const handleTabChange = (_event, value) => {
    setActiveTab(value);
  };

  const activeComponent = useMemo(() => {
    switch (activeTab) {
      case 'country-feasibility':
        return <CountryFeasibility />;
      case 'site-feasibility':
        return <SiteFeasibility />;
      case 'feasibility-questionnaire':
      default:
        return <FeasibilityQuestionnaire />;
    }
  }, [activeTab]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 2 }} elevation={0}>
        <Typography variant="h5" gutterBottom>
          Feasibility
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{ mb: 3 }}
        >
          {tabConfig.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.id} />
          ))}
        </Tabs>

        {activeComponent}
      </Paper>
    </Box>
  );
};

export default Feasibility;
